// Duplicated from service-desk's ProjectSelectColumn/utilsProjectSelect.tsx.
// Code duplication is accepted between dashboard-ui and service-desk (sealed UMD boundary).
import { ApolloClient } from '@apollo/client';
import {
  QueryWorkItemCounts,
  QueryWorkItemsForProject,
  QueryWorkItemsForProjectPerWorker,
} from './queries';
import { CollectionWithWorkItemCounts, WorkitemStatus } from './types';

const parseWorkItemData = (data: any): any[] => {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch {
      return [];
    }
  }
  return Array.isArray(data) ? data : [];
};

export async function fetchProjectsWithCounts(
  collectionIds: string[],
  collections: CollectionWithWorkItemCounts[],
  activeContextRoles: string[],
  workerId: string,
  apolloClient: ApolloClient<any>,
  isPolling: boolean,
): Promise<CollectionWithWorkItemCounts[]> {
  const isCQAManager = activeContextRoles.includes('cqa_manager');

  let managerData: any[] = [];
  if (isCQAManager) {
    try {
      const resp = await apolloClient.mutate({
        mutation: QueryWorkItemCounts,
        variables: { workItemQuery: { query: QueryWorkItemsForProject(collectionIds) } },
      });
      managerData = parseWorkItemData(resp?.data?.QueryWorkItems?.data);
    } catch (err) {
      if (!isPolling) console.error('Error fetching manager work item counts:', err);
    }
  }

  let workerData: any[] = [];
  try {
    const resp = await apolloClient.mutate({
      mutation: QueryWorkItemCounts,
      variables: { workItemQuery: { query: QueryWorkItemsForProjectPerWorker(collectionIds, workerId) } },
    });
    workerData = parseWorkItemData(resp?.data?.QueryWorkItems?.data);
  } catch (err) {
    if (!isPolling) console.error('Error fetching per-worker work item counts:', err);
  }

  return collections.map(project => {
    const mgr = managerData.find((p: any) => p.qa_collection_id === project.collection_id);
    const wrk = workerData.find((p: any) => p.qa_collection_id === project.collection_id);

    const assignedToMeCount = isCQAManager ? (wrk?.in_progress_workitems ?? 0) : 0;
    const inCqaCount = isCQAManager ? (mgr?.in_progress_workitems ?? 0) : (wrk?.in_progress_workitems ?? 0);
    const cqaCompleteCount = isCQAManager ? (mgr?.completed_workitems ?? 0) : (wrk?.completed_workitems ?? 0);
    const cqaApprovedCount = isCQAManager ? (mgr?.approved_workitems ?? 0) : 0;
    const cqaClosedCount = isCQAManager ? (mgr?.closed_workitems ?? 0) : 0;

    return {
      ...project,
      workItemCounts: {
        [WorkitemStatus.ASSIGNED_TO_ME]: assignedToMeCount,
        [WorkitemStatus.IN_CQA]: inCqaCount,
        [WorkitemStatus.CQA_COMPLETE]: cqaCompleteCount,
        [WorkitemStatus.CQA_APPROVED]: cqaApprovedCount,
        [WorkitemStatus.CQA_CLOSED]: cqaClosedCount,
      },
    };
  });
}
